import { gql } from '@apollo/client';

export const GET_NUMBER_BY_UUID = gql`
  query getNumberByUUID($input: GetNumberByUUIDInput!) {
    getNumberByUUID(input: $input) {
      portaDonorRio
    }
  }
`;
